import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import animateScrollTo from 'animated-scroll-to';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';

import Link from 'components/common/Link';
import IconLogo from 'components/icons/IconLogo';
import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

import LandingHeaderNavigation from './LandingHeaderNavigation';
import LandingHeaderMobileMenu from './LandingHeaderMobileMenu';

const styles = theme => ({
  root: {
    height: '64px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: 'none',
    zIndex: 1200,
    backgroundColor: theme.palette.common.white,
  },
  rootSticky: {
    boxShadow: theme.shadows[2],
  },
  heading: {
    display: 'flex',
    marginLeft: 25,
    lineHeight: '36px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: 15,
    },
  },
  defaultHeaderNavigation: {
    marginRight: 25,
    [theme.breakpoints.down('xs')]: {
      marginRight: 15,
    },
  },
  button: {
    display: 'flex',
    padding: 0,
    verticalAlign: 'top',
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover, &:focus': {
      opacity: '0.6',
      background: 'transparent',
    },
  },
  iconLogo: {
    width: 90,
    height: 30,
    [theme.breakpoints.up('sm')]: {
      height: 36,
      width: 106,
    },
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: 1190,
    margin: '0 auto',
  },
  typographySlogan: {
    color: theme.palette.secondary.A700,
    fontSize: pxToRem(10),
    letterSpacing: pxToEm(0.75, 10),
    marginLeft: 8,
    marginTop: 5,
    textTransform: 'uppercase',
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
});

class LandingHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sticky: false,
      menuOpen: false,
    };

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onScroll);
    this.onScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onScroll);
  }

  onResize() {
    this.onMenuClose();
    this.onScroll();
  }

  onScroll() {
    const scrollTop = window.scrollY || window.scrollTop;

    if (scrollTop > 24) {
      this.setState({ sticky: true });
    } else {
      this.setState({ sticky: false });
    }

    return false;
  }

  onMenuButtonClick() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  onMenuClose() {
    this.setState({ menuOpen: false });
  }

  render() {
    const { classes, location, history } = this.props;
    const { sticky, menuOpen } = this.state;
    return (
      <AppBar
        position="fixed"
        color="secondary"
        className={classNames(classes.root, {
          [classes.rootSticky]: sticky && !menuOpen,
        })}
      >
        <div className={classes.content}>
          <div className={classes.heading}>
            <Link
              className={classes.button}
              onClick={() => {
                history.push('/');
                if (location.pathname === '/') {
                  animateScrollTo(0);
                }
              }}
            >
              <IconLogo className={classes.iconLogo} color="dark" />
              <Typography className={classes.typographySlogan}>
                One Toolbox<br />Many Solutions
              </Typography>
            </Link>
          </div>
          <LandingHeaderNavigation
            className={classes.defaultHeaderNavigation}
            onMenuButtonClick={this.onMenuButtonClick}
          />
          <LandingHeaderMobileMenu
            menuOpen={menuOpen}
            onMenuClose={this.onMenuClose}
          />
        </div>
      </AppBar>
    );
  }
}

LandingHeader.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootSticky: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconLogo: PropTypes.string.isRequired,
    defaultHeaderNavigation: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(
  withStyles(styles)(LandingHeader),
);



// WEBPACK FOOTER //
// ./src/components/common/Layout/LandingHeader/LandingHeader.js